import React from 'react';
import { Box, Grid, Typography, Paper } from '@mui/material';
import { useCurrentUser, useDialog } from 'hooks/common';
import BecomeCreatorModal from './CreateProfileStepper';
import { SparkButton } from 'sharedComponents/UI';
import ArrowsMoneyIcon from 'components/SVG/ArrowsMoney';
import Cart from 'components/SVG/Cart';
import Tools from 'components/SVG/Tools';

function NoMarketPlaceAccount() {
  const { open, closeDialog, openDialog } = useDialog();
  const { applicationUser } = useCurrentUser();

  const creators = [
    { name: 'I am a Writer', img: '/Man.jpg' },
    { name: 'I am a Digital Marketer', img: '/Girl.jpg' },
    { name: 'I am a Designer', img: '/Girl2.jpg' },
  ];

  const steps = [
    {
      title: 'Build your Spark',
      desc: 'Design AI-powered workflows using the free Spark Builder.',
      icon: <Tools width='70' height='56.94' />,
    },
    {
      title: 'List & Sell',
      desc: 'Offer your Spark for free or as a paid solution in the Spark Store.',
      icon: <Cart width='70' height='70' />,
    },
    {
      title: 'Earn Recurring Revenue',
      desc: 'Customers use your Sparks and you get paid.',
      icon: <ArrowsMoneyIcon width='70' height='70' />,
    },
  ];

  return (
    <Grid container direction='column'>
      <Grid
        item
        sx={{
          background:
            'radial-gradient(circle at 25% 25%, rgba(68, 17, 187, 0.8) 0%, rgba(0, 7, 28, 0) 50%), radial-gradient(circle at 75% 75%, rgba(68, 17, 187, 0.8) 0%, rgba(0, 7, 28, 1) 70%)',
          textAlign: 'center',
          py: 10,
          px: 2,
          color: '#fff',
        }}
      >
        <Typography variant='h3' fontFamily={'Mont-semibold'} gutterBottom>
          Build Once.{' '}
          <Typography
            sx={{
              background:
                'linear-gradient(270deg, #F5831F 57.62%, #F05251 69.98%, #DE539E 84.11%, #6269B0 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              color: 'transparent',
              display: 'inline-block',
            }}
            variant='h3'
            fontFamily={'Mont-semibold'}
          >
            Earn Forever.
          </Typography>
        </Typography>
        <Typography variant='body1' sx={{ mb: 3 }}>
          Turn your skills into revenue {applicationUser?.attributes?.name} .
        </Typography>
        <SparkButton
          variant='contained'
          size='large'
          sx={{
            background: 'linear-gradient(to right, #e96443, #904e95)',
            borderRadius: '24px',
            textTransform: 'none',
            height: '48px',
          }}
          onClick={openDialog}
        >
          Become a Creator
        </SparkButton>
      </Grid>

      <Grid item sx={{ bgcolor: '#fff', py: 8, px: 3, textAlign: 'center' }}>
        <Grid
          display='flex'
          flexDirection='row'
          alignItems='center'
          justifyContent={'center'}
        >
          <Typography
            variant='h4'
            fontFamily={'Mont-SemiBold'}
            gutterBottom
            className='color-text'
          >
            Join our growing
          </Typography>
          <Typography
            variant='h4'
            fontFamily={'Mont-SemiBold'}
            gutterBottom
            ml={1}
          >
            creator Community
          </Typography>
        </Grid>
        <Grid container justifyContent='center' spacing={3} mt={3}>
          {creators.map((creator, idx) => (
            <Grid item key={idx} xs={6} sm={4} md={3}>
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  borderRadius: 2,
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    width: 100,
                    height: 100,
                    borderRadius: '50%',
                    overflow: 'hidden',
                    position: 'relative',
                  }}
                >
                  <img
                    src={creator.img}
                    alt='avatar'
                    style={{
                      width: '150%',
                      height: '150%',
                      objectFit: 'cover',
                      position: 'absolute',
                      top: '-5px',
                      left: '-30px',
                    }}
                  />
                </Box>

                <Typography variant='body1' fontFamily={'Mont-SemiBold'}>
                  {creator.name}
                </Typography>
              </Paper>
            </Grid>
          ))}
          <Grid item xs={6} sm={4} md={3}>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                borderRadius: 2,
                height: '100%',
                background:
                  'linear-gradient(to right, #0f0c29, #302b63, #24243e)',
                color: '#fff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
              }}
            >
              <Typography variant='subtitle1' fontWeight='bold'>
                What's your expertise?
              </Typography>
              <SparkButton
                variant='contained'
                size='small'
                sx={{
                  background: 'linear-gradient(to right, #e96443, #904e95)',
                  borderRadius: '24px',
                  textTransform: 'none',
                  height: '48px',
                }}
                onClick={openDialog}
              >
                Become a Creator
              </SparkButton>
            </Paper>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        sx={{ py: 8, px: 3, textAlign: 'center', backgroundColor: '#fafafa' }}
      >
        <Grid
          display='flex'
          flexDirection='row'
          alignItems='center'
          justifyContent={'center'}
        >
          <Typography
            variant='h3'
            fontFamily='Mont-SemiBold'
            gutterBottom
            className='color-text'
          >
            How it
          </Typography>
          <Typography
            variant='h3'
            gutterBottom
            ml={1}
            fontFamily='Mont-SemiBold'
            color={'#363636'}
          >
            Works
          </Typography>
        </Grid>
        <Typography
          sx={{ mb: 5, color: (theme) => theme.palette.text.secondary }}
        >
          3 Steps to turning your expertise into cash.
        </Typography>

        <Grid container spacing={4} justifyContent='center'>
          {steps.map((step, idx) => (
            <Grid item xs={12} sm={4} key={idx}>
              <Box
                display='flex'
                flexDirection='column'
                alignItems='center'
                gap={2}
              >
                <Box
                  sx={{
                    fontSize: 40,
                    background:
                      'linear-gradient(to right, #0f0c29, #302b63, #24243e)',
                    color: 'white',
                    borderRadius: '50%',
                    width: 120,
                    height: 120,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {step.icon}
                </Box>
                <Typography variant='h6' fontFamily='Mont-SemiBold'>
                  {step.title}
                </Typography>
                <Typography
                  variant='body2'
                  sx={{
                    maxWidth: 250,
                    textAlign: 'center',
                    color: (theme) => theme.palette.text.secondary,
                  }}
                >
                  {step.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        <SparkButton
          variant='contained'
          size='large'
          sx={{
            background: 'linear-gradient(to right, #e96443, #904e95)',
            borderRadius: '24px',
            textTransform: 'none',
            marginTop: 3,
            height: '48px',
          }}
        >
          Start Selling
        </SparkButton>
      </Grid>

      {open && <BecomeCreatorModal open={open} onClose={closeDialog} />}
    </Grid>
  );
}

export default NoMarketPlaceAccount;
